/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  PackageExtended,
  PackageExtendedFromJSON,
  PackageExtendedFromJSONTyped,
  PackageExtendedToJSON,
  PackageSimpleGroup,
  PackageSimpleGroupFromJSON,
  PackageSimpleGroupFromJSONTyped,
  PackageSimpleGroupToJSON,
} from "./";

/**
 *
 * @export
 * @interface PackageOutput
 */
export interface PackageOutput {
  /**
   *
   * @type {Array<PackageSimpleGroup>}
   * @memberof PackageOutput
   */
  simpleGroup: Array<PackageSimpleGroup>;
  /**
   *
   * @type {Array<PackageExtended>}
   * @memberof PackageOutput
   */
  packages: Array<PackageExtended>;
}

export function PackageOutputFromJSON(json: any): PackageOutput {
  return PackageOutputFromJSONTyped(json, false);
}

export function PackageOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PackageOutput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    simpleGroup: (json["simpleGroup"] as Array<any>).map(
      PackageSimpleGroupFromJSON,
    ),
    packages: (json["packages"] as Array<any>).map(PackageExtendedFromJSON),
  };
}

export function PackageOutputToJSON(value?: PackageOutput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    simpleGroup: (value.simpleGroup as Array<any>).map(
      PackageSimpleGroupToJSON,
    ),
    packages: (value.packages as Array<any>).map(PackageExtendedToJSON),
  };
}
